import { css } from '@emotion/css';
import { nameStyle, maxTextLines} from 'Shared/frontend/Poster';
import { actImageUrl, commonGenresStyle } from 'Shared/frontend/eventPosters/MusicPoster';
import { genreList } from 'Shared/common/Macros';
import { poster } from 'Shared/frontend/SettingsProvider';
import { Show } from 'solid-js';


export function OneAct(P)
{
	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'oneAct');
	
	const posterStyle = () => css(theme().contents,{
		width: '100%',
	});

	const artistNameStyle = () => css(theme().artistNames,{
		width: '100%',
		fontSize: s().artistNamesFontSize ?? theme().artistNames.fontSize
	});

	const imageStyle = () => css(theme().img,{
		display: 'block',
		width: '100%',
		height: 'auto',
	});

	const artistImageStyle = () => css(theme().imageWrap,{});

	const detailsStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		paddingTop: '20px',
		height: '135px', // pushes genres to bottom of poster
	});

	const eventNameStyle = () => css(nameStyle(),{
		width: '100%',
		...maxTextLines(3),
		fontSize: s().nameFontSize ?? theme().name.fontSize
	});

	const genresStyle = () => css(commonGenresStyle(),theme().genres,{
		whiteSpace: 'normal', // we're grouping data so needs to be overridden from commonGenreStyle
		...maxTextLines(2),
	});

	const taglineStyle = () => css(theme().tagline,{
			fontSize: '0.7em',
			lineHeight: '1.5em',
			...maxTextLines(3)
		},
	);


	const hide = () => s()?.hide ?? [];
	const artist = () => P.lineup[0];
	const showName = () => P.name && ! s().hide?.includes('name');

	return (
		<div class={posterStyle()}>
			<div class={artistImageStyle()}>
				<img class={imageStyle()} src={actImageUrl(artist().image)} width={248} height={165.3} />
			</div>
	
			<div class={detailsStyle()}>
				<div class={eventNameStyle()}>
					<Show when={showName()}>
						{ P.name ?? <>&nbsp;</> }
					</Show>
				</div>

				<Show when={!hide().includes('artistName') && artist().name}>
					<div class={artistNameStyle()}>{artist().name}</div>
				</Show>

				<Show when={!hide().includes('artistTagline') && artist().tagline}>
					<div class={taglineStyle()}>{artist().tagline}</div>
				</Show>
			
				<div class={genresStyle()}>
					<Show when={!hide().includes('artistGenres') && artist().mainGenre}>
						{ genreList(artist()) }
					</Show>
				</div>
			</div>
		</div>
	);
}

